import { useContext } from "react";
import { ModuleProvider } from "./module";
import { withModule } from "./withModule";
import { ModuleContext } from "./module-context";

const useModule = () => useContext(ModuleContext);

export { ModuleProvider, useModule, withModule };
